export enum EntryrecordLoginTypeEnum {
  Password = 'password',
  Code = 'code',
  Unknow = 'unknow',
}
